export enum ThemesTextEnum {
  light = 'light',
  dark = 'dark',
  white = 'white',
  brand = 'brand',
  brandLight = 'brand-light',
  brandDark = 'brand-dark'
}
